import { AutogenLayoutManifestMovementQuickInfo } from "./autogen/AutogenLayoutManifestMovementQuickInfo";
import { DataSourceMode, Label, Layout, TableRowDisplayEvent, Textbox, Image } from "@mcleod/components";
import { OrderTabView } from "./OrderTabView";
import { ModelRow, ModelSearchResult, StringUtil } from "@mcleod/core";

export class ManifestMovementQuickInfo extends AutogenLayoutManifestMovementQuickInfo {

    /** This is an event handler for the onRowDisplay event of tableOrders. */
    tableOrdersOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow: ModelRow = tableRow.data as ModelRow;
        const txtOrderId = tableRow.findComponentById("textboxOrderId") as Textbox;
        txtOrderId.addUnderlineWhenMouseOver();
        txtOrderId.addClickListener( () => {
            OrderTabView.navigateTo({ key: modelRow.get("order_id"), newTab: true });
        });
    }

    public static addHoverToDiscoverToManifestIdComponent(manifestIdComponent: Label | Image, movementId: string, manifestId: string) {
        if (StringUtil.isEmptyString(movementId) || StringUtil.isEmptyString(manifestId)) {
            return;
        }
        manifestIdComponent.tooltipDynamicContent = async () => {
            const layout = await Layout.getLoadedLayout("lme/dispatch/ManifestMovementQuickInfo") as ManifestMovementQuickInfo;
            if (layout.mainDataSource !== null) {
                const input = { planned_manifest_id: manifestId, movement_id: movementId };
                const response = await layout.mainDataSource.search(input) as ModelSearchResult;
                if (response) {
                    layout.mainDataSource.setRowsAndMode(DataSourceMode.NONE, response.modelRows);
                }
            }
            return layout;
        };
    }
}
